<template>
    <b-card-body v-if="result">
        
        <table class="table table-md mb-3">
            <thead>
                <tr>
                    <th>Segment</th>
                    <th>Orders</th>
                    <th>Total sale</th>
                    <th>Avg. sale</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in result" :key="item.category">
                    <td>{{item.category}}</td>
                    <td>{{item.orders}}</td>
                    <td>{{$numeral(item.total).multiply(0.8).format("0,0.00")}} kr.</td>
                    <td>{{$numeral(item.total).divide(item.orders).multiply(0.8).format("0,0.00")}} kr.</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th>Total</th>
                    <th>{{ $sum(result, 'orders') }}</th>
                    <th>{{$numeral($sum(result, 'total')).multiply(0.8).format("0,0.00")}} kr.</th>
                    <th>{{$numeral($sum(result, 'total')).divide($sum(result, 'orders')).multiply(0.8).format("0,0.00")}} kr.</th>
                </tr>
            </tfoot>
        </table>

    </b-card-body>
</template>

<script>
import mixin from "../../mixins/area";

export default {
    data: () => ({
        result: null,
    }),
    components: {  },
    watch: {
        entity: {
            deep: true,
            handler() {
                this.getResult();
            }
        }
    },
    computed: {},
    methods: {
        getResult() {
            this.$http.post("/api/module/dashboard/segmentedtailororders", {
                dates: this.entity.dates,
                user: this.entity.user,
                franchise: this.entity.franchise
            }).then(x => {
                this.result = x.data;
            });
        },
    },
    created() {
        this.getResult();
    },
    mounted() {

    },
    mixins: [mixin]
};
</script>

<style lang="scss">


</style>